<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div v-if="showForm" class="form">
      <div><h3>{{ form.chavecliente }}</h3><b>Pacote:</b> {{ form.packname }}</div>
      <textarea v-model="form.anotacoes" placeholder="Anotações referentes a atualização deste pacote neste cliente específico..."></textarea>
      <button @click.prevent="saveAnotacoes()" class="btn btn-success">Salvar anotações</button>
      <button @click.prevent="closeForm()" class="btn btn-muted">Sair sem alterar</button>
    </div>
    <div class="text-left">
      <h3>
        <router-link to="/pacotes">Pacotes</router-link> 
        <router-link to="/pacotes/resumo" v-if="rel!==1"> | Resumo</router-link>
        <template v-if="pacotes[0] !== undefined && rel === 1"> » {{ pacotes[0].packname }} | <small>Atualizados {{ pacotesAtu }} / Pendentes {{ pacotes.length - pacotesAtu }}</small></template>
      </h3>
    </div>
    <table v-if="rel===0" class="table-striped">
      <tr>
        <td>
          <a class="glyphicon glyphicon-collapse-down" @click.prevent="collapseAll()"></a>
          Pacote
        </td>
        <td class="text-center">File(s)</td>
        <td class="text-center">Data Upload</td>
        <td class="text-center">Data Download</td>
        <td class="text-center">Status</td>
      </tr>
    <template v-for="item,key in pacotes">
      <template v-if="item[0].razao !== null">
        <tr>
          <td colspan="4" class="bg-header">
            <a class="glyphicon glyphicon-collapse-down" data-toggle="collapse" :data-target="'.'+key"></a>
            <b>{{ key }}</b> - <span class="razao">{{ item[0].razao }}</span>
          </td>
          <td class="text-center bg-header">
            <b class="text-success">{{ item[0].total - item[0].pendentes }} Atualizada(s)</b>
            <b v-if="item[0].pendentes>0" class="text-danger">  |   {{ item[0].pendentes }} Pendente(s)</b>
          </td>
        </tr>
        <tr v-for="x in item" :class="(nocollapse === true)? '' : 'collapse ' + key ">
          <td>
            <a @click.prevent="loadAnotacao(x.cod,key)" class="glyphicon glyphicon-pushpin"></a> 
            <a @click.prevent="select4thispack(x.cod)" title="Ver os clientes desta atualização">{{ x.packname }}</a>
          </td>
          <td class="text-center"><b>{{ x.qtd }}</b></td>
          <td class="text-center">{{ formatData(x.dt_upload) }}</td>
          <td class="text-center">
            {{ x.dt_download !== null? formatData(x.dt_download) : '-' }}
            <a @click.prevent="updateDtDownload(x.cod,key,true)" v-if="x.dt_download === null" class="glyphicon glyphicon-ok-circle text-success" title="Marcar como atualizado"></a>
            <a @click.prevent="updateDtDownload(x.cod,key,false)" v-else class="glyphicon glyphicon-remove-circle text-danger" title="Apagar data de download"></a>
          </td>
          <td class="text-center">
            <i v-if="x.dt_download !== null" class="glyphicon glyphicon-ok-sign text-success"></i>
            <i v-else class="glyphicon glyphicon-remove-sign text-danger"></i>
          </td>
        </tr>
      </template>
    </template>
    </table>
    <table v-if="rel===1">
        <tr>
          <td>Cliente</td>
          <td>Contato</td>
          <td class="text-center">File(s)</td>
          <td class="text-center">Data Upload</td>
          <td class="text-center">Data Download</td>
          <td class="text-center">Status</td>
        </tr>
        <template v-for="x in pacotes">
          <tr v-if="x.razao !== null">
            <td>
              <a @click.prevent="loadAnotacao(x.cod,x.chavecliente)" class="glyphicon glyphicon-pushpin"></a> 
              <a v-if="x.link!==''" :href="x.link" target="_blank" class="glyphicon glyphicon-home"></a>
              {{ x.chavecliente }}
              <span v-if="x.situacao==='2'" class="text-danger"><b class="glyphicon glyphicon-lock"></b> Bloqueado</span>
            </td>
            <td>
              <template v-for="tel in x.telefone">
                <span>{{maskTelefone(tel.numero)}}</span><br/>
              </template>
            </td>
            <td class="text-center"><b>{{ x.qtd }}</b></td>
            <td class="text-center">{{ formatData(x.dt_upload) }}</td>
            <td class="text-center">
              {{ x.dt_download !== null? formatData(x.dt_download) : '-' }}
              <a @click.prevent="updateDtDownload(x.cod,x.chavecliente,true)" v-if="x.dt_download === null" class="glyphicon glyphicon-ok-circle text-success" title="Marcar como atualizado"></a>
              <a @click.prevent="updateDtDownload(x.cod,x.chavecliente,false)" v-else class="glyphicon glyphicon-remove-circle text-danger" title="Apagar data de download"></a>
            </td>
            <td class="text-center">
              <i v-if="x.dt_download !== null" class="glyphicon glyphicon-ok-sign text-success"></i>
              <i v-else class="glyphicon glyphicon-remove-sign text-danger"></i>
            </td>
          </tr>
        </template>
      </table>
      <!-- Resumo -->
      <table v-if="rel===2" class="center">
          <tr>
            <td>Atualização</td>
            <td>Atualizados</td>
            <td class="text-center">Pendentes</td>
            <td class="text-center">Último Download</td>
            <td class="text-center">Upload</td>
          </tr>
          <template v-for="(x,index) in pacotes">
            {{percentual(x.downloads, x.total, index)}}
            <tr>
              <td><a @click.prevent="select4thispack(x.cod)" title="Ver os clientes desta atualização">{{ x.packname }}</a></td>
              <td>
                <b :class="x.percent < 30? 'text-danger' : x.percent < 50 ? 'text-warning' : 'text-success'">
                  {{x.percent < 100? x.percent + '%' : 'OK'}}
                </b>
              </td>
              <td>{{x.total - x.downloads}}</td>
              <td>{{formatData(x.last_download)}}</td>
              <td>{{formatData(x.dt_upload)}}</td>
            </tr>
          </template>
        </table>

      <br><br><br>
  </div>
</template>

<script>
  import swal from 'sweetalert'
  import Mask from './Mask.js'
  export default {
    name: 'emailrel',
    data () {
      return {
        loading: false,
        showForm: false,
        nocollapse: false,
        rel: 0,
        pacotes: [],
        pacotesAtu: 0,
        form: {
          codatu: 0,
          packname: '',
          chavecliente: '',
          anotacoes: ''
        }
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getpack.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            // console.log(response.body)
            if (response.body.status) {
              this.pacotes = response.body.rows
              if (this.rel === 1) {
                this.pacotesAtu = 0
                this.pacotes.forEach(item => { if (item.dt_download !== null) this.pacotesAtu++ })
              }
            } else {
              this.pacotes = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      loadAnotacao (codatu, chavecliente) {
        const url = './api/php/getpack.php'
        this.$http.post(url, JSON.stringify({'codatu': codatu, 'chavecliente': chavecliente})).then(
          function (response) {
            console.log(response)
            if (response.body.status) {
              this.fetchDataAnotacao(response.body.result)
            } else {
              swal('Ops...', response.body.erro, 'error')
              this.closeForm()
            }
          },
          function (error) {
            console.log(error)
            this.closeForm()
          }
        )
      },
      updateDtDownload (codatu, chavecliente, status) {
        const url = './api/php/addpack.php'
        this.$http.post(url, JSON.stringify({'codatu': codatu, 'chavecliente': chavecliente, 'status': status})).then(
          function (response) {
            console.log(response)
            if (response.body.status) {
              swal('Ok', '', 'success')
              if (this.$route.params.id !== undefined) {
                this.rel = 1
                this.load({'rel': true, 'cod': this.$route.params.id})
              } else {
                this.rel = 0
                this.load({'rel': true})
              }
            } else {
              swal('Ops...', response.body.erro, 'error')
              this.closeForm()
            }
          },
          function (error) {
            console.log(error)
            this.closeForm()
          }
        )
      },
      saveAnotacoes () {
        const url = './api/php/addpack.php'
        this.$http.post(url, JSON.stringify({'codatu': this.form.codatu, 'chavecliente': this.form.chavecliente, 'anotacoes': this.form.anotacoes})).then(
          function (response) {
            console.log(response)
            if (response.body.status) {
              swal('Ok', '', 'success')
              this.closeForm()
            } else {
              swal('Ops...', response.body.erro, 'error')
              this.closeForm()
            }
          },
          function (error) {
            console.log(error)
            this.closeForm()
          }
        )
      },
      fetchDataAnotacao (o) {
        this.form.codatu = o.cod
        this.form.packname = o.packname
        this.form.chavecliente = o.chavecliente
        this.form.anotacoes = o.anotacoes
        this.showForm = true
      },
      closeForm () {
        this.showForm = false
        this.form.codatu = 0
        this.form.packname = ''
        this.form.chavecliente = ''
        this.form.anotacao = ''
      },
      select4thispack (cod) {
        this.$router.push({path: `/pacotes/${cod}`})
      },
      formatData (date) {
        return (date !== undefined && date !== null) ? date.substring(8, 11) + '-' + date.substring(5, 7) + '-' + date.substring(0, 4) : ''
      },
      percentual (amostra, total, index) {
        this.pacotes[index].percent = (amostra / total * 100).toFixed(2)
      },
      collapseAll () {
        if (this.nocollapse) {
          this.$router.push({path: `?lap=0`})
        } else {
          this.$router.push({path: `/pacotes`})
        }
      }
    },
    created: function () {
      this.maskTelefone = Mask.telefone
      if (this.$route.query.lap === '0') {
        console.log('No colapse set true! via created')
        this.nocollapse = true
      }
      if (this.$route.params.id !== undefined) {
        if (this.$route.params.id === 'resumo') {
          console.log('Relatório por Atualização')
          this.rel = 2
          this.load({'rel': true, 'cod': 0})
        } else {
          this.rel = 1
          this.load({'rel': true, 'cod': this.$route.params.id})
        }
      } else {
        console.log('Relatorio clientes')
        this.rel = 0
        this.load({'rel': true})
      }
    },
    watch: {
      '$route' (to, from) {
        if (this.$route.query.lap === '0') {
          this.nocollapse = true
          console.log('No colapse set true! via watch')
        }
        if (this.$route.params.id !== undefined) {
          if (this.$route.params.id === 'resumo') {
            console.log('Relatório por Atualização')
            this.rel = 2
            this.load({'rel': true, 'cod': 0})
          } else {
            this.rel = 1
            this.load({'rel': true, 'cod': this.$route.params.id})
          }
        } else {
          console.log('Relatorio clientes')
          this.rel = 0
          this.load({'rel': true})
        }
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
        width: 80vw;
        margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 100%;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    .table-striped .bg-header {
      background: #d9d9d9;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    i.glyphicon {
      font-size: 24px;
    }
    .form {
      position: absolute;
      padding: 30px;
      background: #fff;
      border: 1px solid #dedede;
      box-shadow: 0px 0px 15px #333;
      z-index: 10;
      width: 60vw;
      left: 20vw;
      top: 30vh;
    }
    .form textarea {
      width: 100%;
    }
    .razao {
      color: rgba(0,0,0,.4);
    }
    table.center tr td:not(:first-child) {
      text-align: center;
    }
    @media (max-width: 499px) {
      .container-fluid {
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      table {
        font: 10px sans-serif;
        width: 100vw;
      }
      .lt500 {
        display: none;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/PackRel.vue